<template>
    <li :class="['message', { active: isActive || isChecked }]">
        <a href="javascript:void()" @click="showBirthdayGroupView()">
            <div class="actions">
                <span class="action ml-1"><b-form-checkbox v-model="isChecked"></b-form-checkbox></span>
            </div>
            <div class="header d-block">
                <span class="from">{{ group.name }}</span>
                <span class="pull-right"><span class="badge badge-secondary badge-pill"> <small>{{ group.total_contacts }}</small></span></span>
            </div>
            <div class="description">
              {{ formatTime(group.delivery_time) }}
            </div>
        </a>
    </li>
</template>

<script>
import Vue from 'vue'
import {EventBus} from '@/events/bus.event'

export default {
  name: 'BirthdayGroupItem',
  components: {
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    isActive: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
     isChecked: false
    }
  },
  computed: {
  },
  watch: {
    isChecked: function (flag) {
      this.showBirthdayGroupSelection(flag)
    },
  },
  created: function() {
    EventBus.$on('birthday-group-selection-'+this.group.id, this.toggleSelection)
  },
  methods: {
    showBirthdayGroupView: function() {
      this.$emit('show-birthday-group-view', this.group)
    },
    formatTime: function(date) {      
      return date.substr(11, 5)
    },
    showBirthdayGroupSelection: function(flag) {
      this.$emit('show-birthday-group-selection', this.group, flag)
    },
    toggleSelection: function(flag) {
      this.isChecked = flag
      //this.isActive = flag
    },
  }
}
</script>
